import { Component, Input } from '@angular/core'
import { DivisionService, ViewService, AuthService } from '../../services'
import { SearchPanel, Subject } from '../../interfaces'
import { Column, QueryString } from '../../models'
import { Observable } from 'rxjs'
import { ShortDatePipe, TimePipe } from '../../pipes'
import { LoggedUser } from '../../interfaces'

@Component({
  selector: 'division-exams-tab',
  templateUrl: './division-exams.tab.html'
})

export class DivisionExamsTab extends SearchPanel<any> {


  // @ts-expect-error ts-migrate(2564) FIXME: Property 'divisionId' has no initializer and is no... Remove this comment to see the full error message
  @Input() divisionId: string
  columns: Column[] = []
  subjects: Subject[] = []
  user: LoggedUser

  constructor (protected viewService: ViewService, private divisionService: DivisionService, authService: AuthService) {
    super(viewService, 'topic')
    this.params.limit = 50
    this.params.sort = { dateTime: -1 }
    this.user = authService.getCurrentUser()
    console.log(this.user)
  }

  public activate (): void {
    this.loadSubjects()
    this.createColumns()
    this.updateFilter()
  }

  protected fetch (params: QueryString): Observable<any> {
    return this.divisionService.getExams(this.divisionId, params)
  }

  private onExamSelected (exam: any) {
    this.viewService.goToDetail(`divisions/${this.divisionId}/exams`, 'division', exam)
  }

  private createColumns () {
    this.columns = [
      Column.forClick('date', 'TOPIC.DATE', this.onExamSelected.bind(this), true, new ShortDatePipe()),
      Column.forClick('time', 'TOPIC.TIME', this.onExamSelected.bind(this), true, new TimePipe()),
      Column.forClick('title', 'SUBJECT.DETAIL_TITLE', this.onExamSelected.bind(this), true),
      new Column('content', '', false),
    ]
  }

  private loadSubjects () {
    this.divisionService.getSubjects(this.divisionId)
    .subscribe(({ list }) => {
        this.subjects = this.viewService.optionalList(list, {_id: undefined, name: ''})
      },
      this.viewService.handleError
    )
  }
}
